import React from 'react';
import styled from 'styled-components';
import * as colors from '@styles/colors';
import * as fonts from '@styles/fonts';
import {media} from '@styles';
import bgimage from '@images/temp/bg.jpg';
import {PagePadding} from '@components/SectionLayout';
import {Card} from '@components';
import Swiper from 'react-id-swiper';
import {Navigation} from 'swiper/dist/js/swiper.esm';

const params = {
  modules: [Navigation],
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  spaceBetween: 25,
  slidesPerView: 3,
  containerClass: 'swiperContainer',
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 25,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 25,
    },
  },
};

interface SwiperSlideProps {
  title: string;
  image: string;
  link: string;
}

interface SwiperProps {
  data: SwiperSlideProps[];
  title?: string;
}

const SwiperContainer = styled.section<{bgImage?: string}>`
  padding: 75px 35px;
  background-image: ${props =>
    props.bgImage ? `url(${props.bgImage})` : 'none'};
  background-size: cover;
  background-repeat: no-repeat;

  ${media.tablet`padding: 75px 0px;`};

  .swiperContainer {
    overflow: hidden;
    margin: 0 auto;

    ${media.tablet`padding: 0px;`};
  }

  .swiper-button-next,
  .swiper-container-rtl,
  .swiper-button-prev {
    background-image: none;
  }
`;

const SwiperTitle = styled.h1`
  text-align: center;
  font-size: 3.435rem;
  line-height: 3.4375rem;
  color: ${colors.white};
  font-family: ${fonts.geared};
  margin-bottom: 60px;
  padding: 0 70px;
`;

const SwiperList = styled.div`
  position: relative;
  margin: 0 auto;

  ${media.tablet`max-width: 100%;`};
`;

const SwiperCarousel = (props: SwiperProps): JSX.Element => {
  const {data, title} = props;

  return (
    <SwiperContainer bgImage={bgimage}>
      <SwiperTitle>{title ? title : 'EXPLORE INGREDIENTS'}</SwiperTitle>

      <SwiperList>
        <PagePadding>
          <Swiper {...params}>
            {data.map(
              (slide: SwiperSlideProps, index: number): JSX.Element => (
                <div key={index}>
                  <Card
                    link={slide.link}
                    image={slide.image}
                    title={slide.title}
                  />
                </div>
              ),
            )}
          </Swiper>
        </PagePadding>
      </SwiperList>
    </SwiperContainer>
  );
};

export default SwiperCarousel;
